import NoteForm from './NoteForm.container';

export default NoteForm;
